import { render, staticRenderFns } from "./ScadaPointsDialog.vue?vue&type=template&id=32ef7356&scoped=true&"
import script from "./ScadaPointsDialog.vue?vue&type=script&lang=js&"
export * from "./ScadaPointsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScadaPointsDialog.vue?vue&type=style&index=0&id=32ef7356&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef7356",
  null
  
)

export default component.exports